import React from "react";
import MainTitle from "components/MainTitle";

import { Text } from "mondrian-react";
import Success from "pages/Success";

const DependentesSuccess = ({ setForm, formData, navigation, ...props }) => {
  let title = "";
  let text = "";
  if (props.customData.flux === "resend") {
    title = "Convite reenviado com sucesso";
    text = <Text>O dependente que você acabou de escolher receberá um SMS com instruções para finalizar o cadastro nas próximas 72 horas. <br/><br/> Com o seu convite ele poderá ter acesso ao site e app da Claro, aproveite para avisa-lo!</Text>;
  } else if (props.customData.flux === "add") {
    title = "Convite enviado com sucesso";
    text = <Text>O dependente que você acabou de escolher receberá um SMS com instruções para finalizar o cadastro nas próximas 72 horas. Com o seu convite ele poderá ter acesso ao site e app da Claro, aproveite para avisa-lo!</Text>;
  } else if (props.customData.flux === "cancelInvite") {
    title = "Convite cancelado";
    text = <Text>O convite para o dependente foi excluído.</Text>;
  } else if (props.customData.flux === "remove") {
    title = "Dependente removido";
    text = <Text>O dependente foi removido com sucesso.</Text>;
  } else if (props.customData.flux === "selfremove") {
    title = "Você se desvinculou do titular";
    text = <Text>Informamos o titular da linha que você se desvinculou.</Text>;
  }

  return (
    <Success {...props} title={title}>
      {text}
    </Success>
  );
};

export default DependentesSuccess;
